var _defs, _circle, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjectGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276.35 387.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdb71c;}.cls-2{fill:#fff;}.cls-3{fill:#1ca4dd;}.cls-4{fill:#2874af;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Goal_icon_FINAL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 138.18,
    cy: 249.24,
    r: 138.18
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "194.39 330.65 138.18 301.1 81.96 330.65 92.7 268.05 47.22 223.72 110.07 214.59 138.18 157.64 166.28 214.59 229.13 223.72 183.66 268.05 194.39 330.65"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.27 0 88.63 98.22 180.43 98.22 116.07 0 24.27 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "160.28 0 145.96 21.86 191.86 91.91 252.08 0 160.28 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectGoal);
export default __webpack_public_path__ + "static/media/icon-project-goal.e9c575189c881eaa7e929fd4cf2a4178.svg";
export { ForwardRef as ReactComponent };